import { useRouter } from 'next/router'
import { useCallback } from 'react'

/**
 * URL のハッシュフラグメントを扱うためのフック
 */
export const useHash = () => {
  const router = useRouter()
  const hash = extractHash(router.asPath)
  const setHash = useCallback(
    (newHash: string) => {
      router.replace({ hash: newHash }, undefined, { shallow: true })
    },
    [router],
  )
  return { hash, setHash }
}

// URL の # 以降の文字列を取り出すユーティリティ
function extractHash(url: string): string {
  return url.split('#')[1] ?? ''
}
